module.exports = __webpack_public_path__ + "static/media/data-analyst.9fdcbe4c.svg";